// English source keys, matching the other Purchasing message dictionaries.
const es = {
  "View tenders and claim differences": "Consultar licitaciones y diferencias para reclamar",
  "Create local tenders": "Crear licitaciones locales",
  "Edit local tenders": "Editar licitaciones locales",
  "Archive local tenders": "Archivar licitaciones locales",
  "Tenders": "Licitaciones",
  "Tender": "Licitación",
  "Tendered": "Licitado",
  "View this item’s tender prices and dates": "Consulta los precios y fechas de este artículo",
  "Corporate": "Corporativo",
  "Managed by general administration. This record cannot be edited or deleted here.": "Gestionado por administración general. Este registro no se puede editar ni borrar aquí.",
  "Managed by general administration. Inventory policy is set by this business unit.": "Gestionado por administración general. La política de inventario la decide esta unidad de negocio.",
  "View tenders": "Ver licitaciones",
  "Create tenders": "Crear licitaciones",
  "Edit tenders": "Editar licitaciones",
  "Archive tenders": "Archivar licitaciones",
  "Active": "Vigente",
  "Upcoming": "Futura",
  "Expired": "Finalizada",
  "Archived": "Archivada",
  "New local tender": "Nueva licitación local",
  "Edit local tender": "Editar licitación local",
  "New corporate tender": "Nueva licitación corporativa",
  "Edit corporate tender": "Editar licitación corporativa",
  "Close editor": "Cerrar editor",
  "Close": "Cerrar",
  "Cancel": "Cancelar",
  "The price applies to requisitions and orders within its validity period. Receivings and delivery notes keep their actual price.": "El precio se aplica a solicitudes y pedidos dentro de la vigencia. Las recepciones y los albaranes conservan el precio real.",
  "Reference / name": "Referencia / nombre",
  "Item": "Artículo",
  "Select an item": "Selecciona un artículo",
  "Supplier": "Proveedor",
  "Select a supplier linked to this item": "Selecciona un proveedor del artículo",
  "Price per {unit}": "Precio por {unit}",
  "purchase unit": "unidad de compra",
  "Currency": "Moneda",
  "EUR, the currency used in Purchasing requisitions and orders.": "EUR, moneda utilizada en solicitudes y pedidos de Purchasing.",
  "Start date": "Fecha de inicio",
  "End date (optional)": "Fecha de fin (opcional)",
  "Leave blank for no end date. Both dates are included.": "Vacía: sin fecha de fin. Ambas fechas están incluidas.",
  "Saving…": "Guardando…",
  "Save tender": "Guardar licitación",
  "Price differences for claims": "Diferencias para reclamar",
  "Compare the tendered price with the delivery note price. Differences do not block receiving or change its cost. Prices and quantities use the base inventory unit. Draft delivery notes are shown for preliminary review.": "Compara el precio licitado con el del albarán. Las diferencias no bloquean la recepción ni cambian su coste. Precios y cantidades expresados en la unidad base de inventario. Los albaranes en borrador se muestran para revisión previa.",
  "Export CSV": "Exportar CSV",
  "From": "Desde",
  "To": "Hasta",
  "All": "Todos",
  "Apply filters": "Consultar",
  "{count} differences": "{count} diferencias",
  "Amount to review:": "Importe a revisar:",
  "Delivery note / date": "Albarán / fecha",
  "Actual": "Real",
  "Quantity": "Cantidad",
  "Total difference": "Diferencia total",
  "Difference": "Diferencia",
  "Delivery note status": "Estado albarán",
  "Overcharged": "Cobrado de más",
  "Undercharged": "Cobrado de menos",
  "Draft": "Borrador",
  "Verified": "Verificado",
  "Received": "Recibido",
  "Verified with differences": "Verificado con diferencias",
  "Closed": "Cerrado",
  "Cancelled": "Cancelado",
  "With differences": "Con diferencias",
  "Loading differences…": "Cargando diferencias…",
  "No differences match the selected filters.": "No hay diferencias para los filtros seleccionados.",
  "You do not have permission to view tenders.": "No tienes permiso para consultar licitaciones.",
  "Purchasing · Items and families": "Purchasing · Artículos y familias",
  "Agreed prices by item, supplier and validity period.": "Precios acordados por artículo, proveedor y vigencia.",
  "New tender": "Nueva licitación",
  "Edit tender": "Editar licitación",
  "Read only": "Solo lectura",
  "Prices and validity": "Precios y vigencias",
  "Claims": "Reclamaciones",
  "Retry": "Reintentar",
  "Item: {name}": "Artículo: {name}",
  "View all items": "Ver todos los artículos",
  "Search": "Buscar",
  "Item, supplier or reference": "Artículo, proveedor o referencia",
  "Origin": "Origen",
  "All origins": "Todas",
  "Local tenders": "Locales",
  "Corporate tenders": "Corporativas",
  "Validity": "Vigencia",
  "All periods": "Todas las vigencias",
  "Item / reference": "Artículo / referencia",
  "Tender issuer": "Licitador",
  "Central Purchasing": "Central de Compras",
  "Internal": "Interna",
  "Price": "Precio",
  "Status": "Estado",
  "Actions": "Acciones",
  "Item {id}": "Artículo {id}",
  "Supplier {id}": "Proveedor {id}",
  "per {unit}": "por {unit}",
  "until {date}": "hasta {date}",
  "no end date": "sin fecha de fin",
  "Corporate tender": "Corporativa",
  "Local": "Local",
  "Managed by administration": "Gestionada por administración",
  "Edit": "Editar",
  "Confirm archive": "Confirmar archivo",
  "Archive": "Archivar",
  "Loading tenders…": "Cargando licitaciones…",
  "No tenders match these filters.": "No hay licitaciones con estos filtros.",
  "Delivery note": "Albarán",
  "Date": "Fecha",
  "Code": "Código",
  "Tendered price": "Precio licitado",
  "Actual price": "Precio real",
  "Unit difference": "Diferencia unitaria",
  "Unable to complete the operation.": "No se ha podido completar la operación.",
  "Tender not found.": "No se ha encontrado la licitación.",
  "Corporate tenders are managed from general administration.": "Las licitaciones corporativas se gestionan desde administración general.",
  "Item and supplier must belong to the active business unit.": "El artículo y el proveedor deben pertenecer a la unidad de negocio activa.",
  "Local tenders cannot be created for corporate-managed items.": "No se pueden crear licitaciones locales para artículos gestionados por administración general.",
  "The supplier is not linked to the selected item.": "El proveedor no está vinculado al artículo seleccionado.",
  "Tender prices use the item's purchase unit.": "El precio licitado se expresa en la unidad de compra del artículo.",
  "Select an active currency.": "Selecciona una moneda activa.",
  "Corporate tenders can only be archived by general administration.": "Solo administración general puede archivar las licitaciones corporativas.",
  "The end date cannot precede the start date.": "La fecha de fin no puede ser anterior a la de inicio.",
  "A non-negative price with at most eight decimals is required.": "Introduce un precio igual o superior a cero, con un máximo de ocho decimales.",
  "Purchasing tenders currently support EUR only.": "Las licitaciones de Purchasing solo admiten EUR actualmente.",
  "The dates overlap tender {id} for this item and supplier.": "Las fechas se solapan con la licitación {id} de este artículo y proveedor.",
  "Unable to save or load tenders.": "No se han podido guardar o cargar las licitaciones.",
  "Access denied: insufficient permissions": "Acceso denegado: permisos insuficientes",
  "PO allocation exceeds the document quantity.": "La cantidad asignada a pedidos supera la cantidad del albarán.",
  "Linked purchase order does not match this delivery note.": "El pedido vinculado no corresponde a este albarán.",
  "Tender and delivery note currencies differ; no automatic conversion is applied.": "Las monedas de la licitación y del albarán son distintas; no se aplica una conversión automática.",
  "The selected price unit does not belong to this item.": "La unidad de precio seleccionada no pertenece a este artículo.",
  "Item not found in the active business unit.": "No se ha encontrado el artículo en la unidad de negocio activa.",
  "A valid purchase date (YYYY-MM-DD) is required.": "Introduce una fecha de compra válida (AAAA-MM-DD).",
  "An active business unit and item are required.": "Se requieren una unidad de negocio activa y un artículo.",
  "The supplier is not assigned to this item in the active business unit.": "El proveedor no está asignado a este artículo en la unidad de negocio activa.",
  "Invalid supplier.": "El proveedor no es válido.",
  "Start date must not follow end date.": "La fecha de inicio no puede ser posterior a la de fin.",
  "Invalid starts_on; use YYYY-MM-DD.": "La fecha de inicio no es válida; utiliza AAAA-MM-DD.",
  "Invalid ends_on; use YYYY-MM-DD.": "La fecha de fin no es válida; utiliza AAAA-MM-DD.",
  "Invalid active business unit.": "La unidad de negocio activa no es válida.",
  "Invalid item_id.": "El artículo no es válido.",
  "Invalid supplier_id.": "El proveedor no es válido."
};

const ca = {
  "Tender issuer": "Licitador",
  "Central Purchasing": "Central de Compres",
  "Internal": "Interna",
};
const isSpanish = (languageId) => String(languageId || "en").toLowerCase().startsWith("es");
const isCatalan = (languageId) => String(languageId || "en").toLowerCase().startsWith("ca");
const translate = (languageId, key, params = {}) => {
  const source = String(key ?? "");
  const overlap = source.match(/^The dates overlap tender (\d+) for this item and supplier\.$/);
  const template = overlap ? "The dates overlap tender {id} for this item and supplier." : source;
  const values = overlap ? { ...params, id: overlap[1] } : params;
  const messages = isSpanish(languageId) ? es : isCatalan(languageId) ? ca : {};
  return (messages[template] ?? template)
    .replace(/\{(\w+)\}/g, (match, name) => values[name] ?? match);
};
const translators = {
  es: (key, params) => translate("es", key, params),
  ca: (key, params) => translate("ca", key, params),
  en: (key, params) => translate("en", key, params),
};
export const getTenderTranslator = (languageId) => translators[isSpanish(languageId) ? "es" : isCatalan(languageId) ? "ca" : "en"];
export const tenderLocale = (languageId) => isSpanish(languageId) ? "es-ES" : "en-GB";
export const tenderMoney = (value, currency = "EUR", languageId = "en") => `${Number(value || 0).toLocaleString(tenderLocale(languageId), { maximumFractionDigits: 8 })} ${currency}`;
export const TENDER_PERIOD_KEYS = { active: "Active", future: "Upcoming", expired: "Expired", archived: "Archived" };
const statusKeys = { ...TENDER_PERIOD_KEYS, overcharged: "Overcharged", undercharged: "Undercharged", draft: "Draft", received: "Received", verified: "Verified", verified_with_differences: "Verified with differences", closed: "Closed", cancelled: "Cancelled", differences: "With differences" };
export const tenderStatusLabel = (status, languageId) => getTenderTranslator(languageId)(statusKeys[status] || status || "");
